/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { ImportResults } from './ImportResults';
import {
  ImportResultsFromJSON,
  ImportResultsFromJSONTyped,
  ImportResultsToJSON,
} from './ImportResults';

/**
 *
 * @export
 * @interface PhoneCsv
 */
export interface PhoneCsv {
  /**
   *
   * @type {string}
   * @memberof PhoneCsv
   */
  authorId?: string;
  /**
   *
   * @type {string}
   * @memberof PhoneCsv
   */
  authorKey?: string;
  /**
   *
   * @type {Array<any>}
   * @memberof PhoneCsv
   */
  columns?: Array<any>;
  /**
   *
   * @type {number}
   * @memberof PhoneCsv
   */
  companyId: number;
  /**
   *
   * @type {string}
   * @memberof PhoneCsv
   */
  csvId?: string;
  /**
   *
   * @type {number}
   * @memberof PhoneCsv
   */
  dateCreated?: number;
  /**
   *
   * @type {string}
   * @memberof PhoneCsv
   */
  dateCreatedIso?: string;
  /**
   *
   * @type {number}
   * @memberof PhoneCsv
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof PhoneCsv
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {string}
   * @memberof PhoneCsv
   */
  downloadUrl?: string;
  /**
   *
   * @type {string}
   * @memberof PhoneCsv
   */
  filename?: string;
  /**
   *
   * @type {string | null}
   * @memberof PhoneCsv
   */
  gcsFilename?: string | null;
  /**
   *
   * @type {string}
   * @memberof PhoneCsv
   */
  id: string;
  /**
   *
   * @type {ImportResults}
   * @memberof PhoneCsv
   */
  importResults?: ImportResults;
  /**
   *
   * @type {string}
   * @memberof PhoneCsv
   */
  key: string;
  /**
   *
   * @type {Array<any>}
   * @memberof PhoneCsv
   */
  labels?: Array<any>;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof PhoneCsv
   */
  mapping?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof PhoneCsv
   */
  name?: string;
  /**
   *
   * @type {number | null}
   * @memberof PhoneCsv
   */
  numRows?: number | null;
  /**
   *
   * @type {string | null}
   * @memberof PhoneCsv
   */
  sortName?: string | null;
  /**
   *
   * @type {string}
   * @memberof PhoneCsv
   */
  state?: PhoneCsvStateEnum;
  /**
   *
   * @type {Array<any>}
   * @memberof PhoneCsv
   */
  tags?: Array<any>;
}

/**
 * @export
 */
export const PhoneCsvMappingEnum = {
  E164: 'e164',
  Dnc: 'dnc',
  DncScope: 'dnc_scope',
  DncExpiration: 'dnc_expiration',
  Dnt: 'dnt',
  DntScope: 'dnt_scope',
  DntExpiration: 'dnt_expiration',
  Consent: 'consent',
  Validity: 'validity',
  DoNotImport: 'do_not_import',
} as const;
export type PhoneCsvMappingEnum =
  (typeof PhoneCsvMappingEnum)[keyof typeof PhoneCsvMappingEnum];

/**
 * @export
 */
export const PhoneCsvStateEnum = {
  Pending: 'pending',
  Launching: 'launching',
  Scheduled: 'scheduled',
  Active: 'active',
  Paused: 'paused',
  Complete: 'complete',
  Error: 'error',
  Deleted: 'deleted',
} as const;
export type PhoneCsvStateEnum =
  (typeof PhoneCsvStateEnum)[keyof typeof PhoneCsvStateEnum];

/**
 * Check if a given object implements the PhoneCsv interface.
 */
export function instanceOfPhoneCsv(value: object): value is PhoneCsv {
  if (!('companyId' in value) || value['companyId'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function PhoneCsvFromJSON(json: any): PhoneCsv {
  return PhoneCsvFromJSONTyped(json, false);
}

export function PhoneCsvFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PhoneCsv {
  if (json == null) {
    return json;
  }
  return {
    authorId: json['author_id'] == null ? undefined : json['author_id'],
    authorKey: json['author_key'] == null ? undefined : json['author_key'],
    columns: json['columns'] == null ? undefined : json['columns'],
    companyId: json['company_id'],
    csvId: json['csv_id'] == null ? undefined : json['csv_id'],
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateCreatedIso:
      json['date_created_iso'] == null ? undefined : json['date_created_iso'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    downloadUrl:
      json['download_url'] == null ? undefined : json['download_url'],
    filename: json['filename'] == null ? undefined : json['filename'],
    gcsFilename:
      json['gcs_filename'] == null ? undefined : json['gcs_filename'],
    id: json['id'],
    importResults:
      json['import_results'] == null
        ? undefined
        : ImportResultsFromJSON(json['import_results']),
    key: json['key'],
    labels: json['labels'] == null ? undefined : json['labels'],
    mapping: json['mapping'] == null ? undefined : json['mapping'],
    name: json['name'] == null ? undefined : json['name'],
    numRows: json['num_rows'] == null ? undefined : json['num_rows'],
    sortName: json['sort_name'] == null ? undefined : json['sort_name'],
    state: json['state'] == null ? undefined : json['state'],
    tags: json['tags'] == null ? undefined : json['tags'],
  };
}

export function PhoneCsvToJSON(value?: PhoneCsv | null): any {
  if (value == null) {
    return value;
  }
  return {
    author_id: value['authorId'],
    author_key: value['authorKey'],
    columns: value['columns'],
    company_id: value['companyId'],
    csv_id: value['csvId'],
    date_created: value['dateCreated'],
    date_created_iso: value['dateCreatedIso'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    download_url: value['downloadUrl'],
    filename: value['filename'],
    gcs_filename: value['gcsFilename'],
    id: value['id'],
    import_results: ImportResultsToJSON(value['importResults']),
    key: value['key'],
    labels: value['labels'],
    mapping: value['mapping'],
    name: value['name'],
    num_rows: value['numRows'],
    sort_name: value['sortName'],
    state: value['state'],
    tags: value['tags'],
  };
}
